<!-- Breadcrumbs -->
<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
        <ng-container *ngFor="let item of breadcrumbs; let last = last">
            <ng-container *ngIf="last">
                <strong *tuiItem tuiFade>{{ item }}</strong>
            </ng-container>
            <ng-container *ngIf="!last">
                <button *tuiItem tuiLink type="button">{{ item }}</button>
            </ng-container>
        </ng-container>
    </tui-breadcrumbs>

    <button [routerLink]="['/admin/manual-records/add-edit']"  tuiButton type="button"  [appDisableUnlessPermission]="'EXTRA_CHARGES_CREATE'">
        Add New Manual Record
    </button>
</nav>

<!-- Heading -->
<div class="items-center flex justify-between">
    <p class="text-[1.25rem] font-bold mt-[0.9rem] text-[#000000A6]">View Extra Charges or Procedures</p>
</div>

<!-- Search + Filters -->
<search class="lg:w-[70%] mt-4" tuiSearch style="padding-left: 0">
    <fieldset class="flex items-center gap-4 border-none">
        <div class="w-[300px]">
            <tui-textfield iconStart="@tui.search">
                <input [formControl]="form.controls.search" (keydown)="onSearchEnter($event)" placeholder="Search by procedure or nurse" tuiTextfield />
            </tui-textfield>
        </div>
        <form class="min-w-[500px]" [formGroup]="dateForm">
            <tui-input-date-range tuiTextfieldSize="m" formControlName="testValue" tuiUnfinishedValidator="Finish filling the field">
                Choose dates
                <input placeholder="From - To" tuiTextfieldLegacy />
            </tui-input-date-range>
        </form>

         <button (click)="loadManualRecords()" appearance="secondary" size="m" tuiButton type="button" class="w-full sm:w-auto"
    style="border: 2px solid #e5e7ea; font-weight: 800">
    Search
  </button>

        <button appearance="flat" iconStart="@tui.rotate-cw" tuiButton type="reset" (click)="clearFilters()">
            Clear
        </button>
    </fieldset>
</search>

<!-- Totals -->
<!-- <div *ngIf="!isLoading" class="flex justify-end items-center mt-2 text-sm text-gray-600">
    Total Grand Total: LKR {{ totalGrandTotal }}
</div> -->

<!-- Loader -->
<div *ngIf="isLoading" class="h-[400px] flex items-center justify-center">
    <tui-loader />
</div>

<!-- Table -->
<div *ngIf="!isLoading" class="w-full mt-5 overflow-x-auto">
    <table tuiTable [size]="size" [style.width.rem]="120">
        <thead>
            <tr>
                <th tuiTh>No.</th>
                <th tuiTh>Procedure</th>
                <th tuiTh>Patient</th>
                <th tuiTh>Address</th>
                <th tuiTh>Contact</th>
                <th tuiTh>Nurse</th>
                <th tuiTh>Doctor</th>
                <!-- <th tuiTh>Charge</th> -->
                <th tuiTh>Payment</th>
                <th tuiTh>Date</th>
                <th tuiTh>Actions</th>
            </tr>
        </thead>

        <tbody tuiTbody>
            <tr *ngFor="let record of procedures">
                <td tuiTd>{{ record.chargeRefNo }}</td>
                <td tuiTd>{{ record.procedure }}</td>
                <td tuiTd>{{ record.clientName || 'N/A' }}</td>
                <td tuiTd>{{ record.clientAddress || 'N/A' }}</td>
                <td tuiTd>{{ record.clientContact || 'N/A' }}</td>
                <td tuiTd>{{ record.nurseName || 'N/A' }}</td>
                <td tuiTd>{{ record.doctorName || 'N/A' }}</td>
                <!-- <td tuiTd>{{ record.charge ? ('LKR ' + record.charge) : 'N/A' }}</td> -->
                <td tuiTd>
                  <span [tuiHint]="getPaymentBreakdown(record)" tuiHintDirection="top" tuiHintMode="onHover" class="text-[#526ED3] ">
                    {{ record.grandTotal ? ('LKR ' + record.grandTotal) : 'N/A' }}
                  </span>
                </td>
                <td tuiTd>{{ record.date | date: 'MMM d, y' }}</td>
                <td tuiTd>
                    <button [routerLink]="['/admin/manual-records/view', record._id]" class="appearance-none bg-white border-none pt-[3px] text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer mr-3">
                        View
                    </button>
                    <button [routerLink]="['/admin/manual-records/add-edit', record._id]" class="appearance-none bg-white border-none pt-[3px] text-[#526ED3] underline decoration-dotted underline-offset-4 hover:text-blue-800 cursor-pointer" [appDisableUnlessPermission]="'EXTRA_CHARGES_UPDATE'">
                        Edit
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- Pagination -->
<div class="flex justify-end items-center mt-5">
    <tui-pagination [index]="pageIndex - 1" [length]="getPageCount()" (indexChange)="onPageChange($event + 1)">
    </tui-pagination>
</div>